import { IColumn } from "@fluentui/react";
import { HelperService } from "../../../services/helper.service";
import { attributes } from "./trailer-type.type";

const helperService: HelperService = HelperService.getInstance();

export const columns: IColumn[] = [
  {
    key: helperService.makeId(10),
    name: "Ansehen",
    fieldName: "edit",
    minWidth: 60,
    maxWidth: 70,
  },
  {
    key: helperService.makeId(10),
    name: attributes.titleDe.label,
    fieldName: attributes.titleDe.name,
    minWidth: 70,
    maxWidth: 510,
    isRowHeader: true,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
  {
    key: helperService.makeId(10),
    name: attributes.titleRu.label,
    fieldName: attributes.titleDe.name,
    minWidth: 70,
    maxWidth: 510,
    isRowHeader: true,
    isResizable: true,
    data: "string",
    isPadded: true,
    onColumnClick: undefined,
  },
];
